import { ApiTypes } from '@/types/server/api.types';

export const getLiveKitToken = async (
	publicId: string,
	candidateAuthToken: string,
	positionAdminAuthToken?: string
) => {
	const response = await fetch(
		`${
			import.meta.env.VITE_SERVER_API_PREFIX
		}/interviews/${publicId}/livekit-token`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-position-admin-token': positionAdminAuthToken ?? '',
				'x-candidate-token': candidateAuthToken,
			},
		}
	);

	const responseData =
		(await response.json()) as ApiTypes.TGetLiveKitTokenResponse;

	return responseData;
};
